// Shared dual-scale scoring constants. Imported by the blueprint editor
// (where 1–10 required levels are picked), the assessment form (where
// 1–5 evaluations are picked), and the methodology help page (which
// renders both tables side-by-side). Keeping the labels in one place
// stops the editor and the help page from drifting apart.

export const REQUIRED_LEVEL_ANCHOR_LABELS: Record<number, string> = {
  1: "Minimal / not required",
  2: "Minimal / not required",
  3: "Foundational / supporting",
  4: "Foundational / supporting",
  5: "Solid practitioner",
  6: "Solid practitioner",
  7: "Advanced / leads in this area",
  8: "Advanced / leads in this area",
  9: "Expert / sets direction, solves complex problems independently",
  10: "Expert / sets direction, solves complex problems independently",
};

export interface EvaluationAnchor {
  score: number;
  label: string;
  short: string;
}

export const EVALUATION_ANCHORS: EvaluationAnchor[] = [
  { score: 1, label: "Clear evidence of not meeting requirement", short: "Not met" },
  { score: 2, label: "Partially meets; material gaps", short: "Partial" },
  { score: 3, label: "Meets requirement (baseline hire standard)", short: "Meets" },
  { score: 4, label: "Strongly meets; above standard", short: "Strong" },
  { score: 5, label: "Significantly exceeds; standout", short: "Standout" },
];

export function shortAnchorFor(score: number | null | undefined): string | null {
  if (score == null) return null;
  return EVALUATION_ANCHORS.find((a) => a.score === score)?.short ?? null;
}
